import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  resetStepTwoState,
  setPaymentInstrument,
} from '../make-payment/step-two-amount/makePaymentStepTwoReducer';
import { resetState } from './payPlanReducer';
import {
  EditPaymentScheduleButtonContainer,
  PaymentScheduleCancelButton,
  SaveNewPaymentScheduleButton,
} from './styles';
import { gaEvent } from '../../../utils/google-analytics';
import {
  checkSaveDisabledUnderlying,
  collapseEventBody,
  updatePayMethodBody,
  updatePayPlanBody,
} from './utils';
import { updatePayPlan } from './policyAPI';
import { useSnackbar } from 'notistack';
import { ga4Event } from '../../../utils/google-analytics-4';
import { Loader } from '../../common/loader';
import { payPlanDateCheck } from '../../../utils/validators/generalValidators';

export const CancelSaveUnderlyingAccountsContainer = (props) => {
  const {
    account,
    dispatch,
    customerId,
    billingStatusCd,
    fullAccount,
    hasOpenBalance,
    instrumentToPayWith,
    isLoading,
    newPlan,
    payPlanDateToPay,
    policyToUpdatePayPlan,
    setPolicyToUpdatePayPlan,
    setShowEditPaymentMethod,
    setShowEditPaymentSchedule,
    setShowPaymentSchedule,
    showPaymentSchedule,
    showEditPaymentMethod,
    showEditPaymentSchedule,
    billingAccountsCountLimit,
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  let initialState = fullAccount.underlyingBillingAccounts
    ? fullAccount.underlyingBillingAccounts.reduce((result, account) => {
        result[account.id] = false;
        return result;
      }, {})
    : { [fullAccount.id]: false }; //for setting each schedule open or closed, if one policy just start with that one false
  const savePaySchedule = async (accountId, account) => {
    const paymentServiceAccountId = account.arPolicy.carrierCd;
    if (payPlanDateCheck(payPlanDateToPay, enqueueSnackbar)) {
      return;
    }
    if (showEditPaymentSchedule[accountId] === true) {
      const body = updatePayPlanBody(
        instrumentToPayWith,
        newPlan,
        Math.abs(payPlanDateToPay),
        customerId,
        paymentServiceAccountId,
      );
      await dispatch(
        updatePayPlan(
          policyToUpdatePayPlan?.policyRef,
          body,
          enqueueSnackbar,
          customerId,
          hasOpenBalance,
          billingAccountsCountLimit,
          billingStatusCd,
        ),
      );
      dispatch(resetState());
      dispatch(resetStepTwoState());
      setShowPaymentSchedule(initialState);
      setShowEditPaymentSchedule(initialState);
      setPolicyToUpdatePayPlan(null);
    }
    if (showEditPaymentMethod[accountId] === true) {
      const body = updatePayMethodBody(
        instrumentToPayWith,
        account,
        customerId,
        paymentServiceAccountId,
      );
      await dispatch(
        updatePayPlan(
          policyToUpdatePayPlan?.policyRef,
          body,
          enqueueSnackbar,
          customerId,
          hasOpenBalance,
          billingAccountsCountLimit,
          paymentServiceAccountId,
        ),
      );
      dispatch(resetState());
      dispatch(resetStepTwoState());
      setShowPaymentSchedule(initialState);
      setShowEditPaymentSchedule(initialState);
      setShowEditPaymentMethod(initialState);
      setPolicyToUpdatePayPlan(null);
    }
  };

  return (
    <EditPaymentScheduleButtonContainer>
      <PaymentScheduleCancelButton
        onClick={() => {
          gaEvent(collapseEventBody);
          ga4Event(collapseEventBody);
          setShowPaymentSchedule({
            ...showPaymentSchedule,
            [account.id]: !showPaymentSchedule[account.id],
          });
          dispatch(setPaymentInstrument(null));
          setShowEditPaymentSchedule(initialState);
          setShowEditPaymentMethod(initialState);
        }}
      >
        Cancel
      </PaymentScheduleCancelButton>
      <SaveNewPaymentScheduleButton
        disabled={
          !checkSaveDisabledUnderlying(
            account.id,
            showEditPaymentSchedule,
            newPlan,
            instrumentToPayWith,
            payPlanDateToPay,
            showEditPaymentMethod,
            isLoading,
          )
        }
        onClick={() => savePaySchedule(account.id, account)}
      >
        Save
      </SaveNewPaymentScheduleButton>
      {isLoading && <Loader loaderwidth="20px" loaderheight="20px" />}
    </EditPaymentScheduleButtonContainer>
  );
};
CancelSaveUnderlyingAccountsContainer.propTypes = {
  billingStatusCd: PropTypes.string,
  customerId: PropTypes.string,
  dispatch: PropTypes.func,
  fullAccount: PropTypes.object,
  instrumentToPayWith: PropTypes.object,
  isLoading: PropTypes.bool,
  payPlanDateToPay: PropTypes.string,
  payPlanOptions: PropTypes.array,
  policyToUpdatePayPlan: PropTypes.object,
  newPlan: PropTypes.object,
  setShowEditPaymentMethod: PropTypes.func,
  setPolicyToUpdatePayPlan: PropTypes.func,
  setShowEditPaymentSchedule: PropTypes.func,
  setShowPaymentSchedule: PropTypes.func,
  showEditPaymentMethod: PropTypes.object,
  showEditPaymentSchedule: PropTypes.object,
  showPaymentSchedule: PropTypes.object,
  account: PropTypes.object,
  hasOpenBalance: PropTypes.bool,
  billingAccountsCountLimit: PropTypes.string,
};
export const mapStateToProps = (state) => ({
  state,
  billingAccounts: state.billingSlice.billingAccounts,
  billingStatusCd: state.configurationSlice?.features?.billingStatusCd
    ? state.configurationSlice.features.billingStatusCd
    : '',
  instrumentToPayWith: state.makePaymentStepTwoSlice.instrumentToPayWith,
  isLoading: state.payPlanSlice.isLoading,
  payPlanDateToPay: state.payPlanSlice.payPlanDateToPay,
  payPlanOptions: state.payPlanSlice.payPlanOptions,
  newPlan: state.payPlanSlice.newPlan,
  customerId: state.customerSlice.customer.systemId,
  editPayPlan: state.configurationSlice.features.features.editPayPlan,
  hasOpenBalance: state.configurationSlice.features.features.hasOpenBalance,
  policies: state.policySlice.policies,
  billingAccountsCountLimit: state.configurationSlice.features.billingAccountsCountLimit,
});

export default connect(mapStateToProps)(CancelSaveUnderlyingAccountsContainer);
